<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between product">
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.type_ar"
                />
                <label for="name_input" class="form-label">النوع (عربي)</label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.type_en"
                />
                <label for="name_input" class="form-label"
                  >النوع (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <!-- <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.description_ar"
                /> -->
                <base-input
                  col="12"
                  type="ckeditor"
                  :required="true"
                  v-model="data.description_ar"
                />
                <label for="name_input" class="form-label">الوصف (عربي)</label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <!-- <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.description_en"
                /> -->
                <base-input
                  col="12"
                  type="ckeditor"
                  :required="true"
                  v-model="data.description_en"
                />
                <label for="name_input" class="form-label"
                  >الوصف (إنجليزي)</label
                >
              </div>
            </div>
            <!-- End Add to website or No  -->
            <div class="buttons_wrapper">
              <button class="base-btn">
                {{ $t("forms.submit") }}
                <span class="btn_loader" v-if="btnIsLoading"></span>
              </button>
            </div>
          </div>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",
  props: ["id"],

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.policy.title"),
          disabled: false,
          href: "/policy",
        },
        {
          text: this.$t("breadcrumb.policy.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Loading
      loadingPage: false,
      // ========== create_data
      data: {
        key: null,
        type_ar: null,
        type_en: null,
        description_ar: null,
        description_en: null,
      },
    };
  },

  computed: {},

  methods: {
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.type_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النوع  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.type_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النوع  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  الوصف   مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "   الوصف  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("key", this.data.type_en);
      submit_data.append("ar[type]", this.data.type_ar);
      submit_data.append("en[type]", this.data.type_en);

      submit_data.append(`ar[description]`, this.data.description_ar);
      submit_data.append(`en[description]`, this.data.description_en);

      submit_data.append(`_method`, "PUT");
      this.axios({
        method: "POST",
        url: `policy/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/policy" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // Get Data
    getData() {
      this.loadingPage = true;
      this.axios({
        method: "GET",
        url: `policy/${this.id}`,
      })
        .then((res) => {
          this.data = res.data.data;
          this.loadingPage = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/policy" });
          this.loadingPage = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}

.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
<style lang="scss">
.ti-input {
  border: 0px !important;
}
.vue-tags-input {
  max-width: unset !important;
  width: 100% !important;
}
</style>
